import PurchaseOrderAddPricingDialog from "./PurchaseOrderAddPricingDialog";

/**
 * @deprecated Prefer PurchaseOrderAddPricingDialog directly.
 */
export default function PriceConfigDialog(props) {
  return (
    <PurchaseOrderAddPricingDialog
      {...props}
      submitLabel={props.submitting ? "Saving…" : "Save and add to order"}
    />
  );
}
